export default __webpack_public_path__ + "static/PPNeueMachina-PlainUltrabold-ad89ec636c8e1818b68765df12dcfa5d.woff";